module.exports = __webpack_public_path__ + "static/media/Malecircled.4103f59b.svg";